<script>
import Cleave from "vue-cleave-component";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { scroller } from "vue-scrollto/src/scrollTo";
import { ref } from "vue";
import clientConfig from "/src/config/client";
import NumInput from "./helpers/NumInput.vue";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBTooltip,
} from "mdb-vue-ui-kit";

import InfoIcon from "./InfoIcon";

export default {
  name: "AboutPanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBTooltip,
    Cleave,
    InfoIcon,
    NumInput,
  },

  setup() {
    const tooltip1 = ref(false);
    //const tooltip2 = ref(false);
    //const tooltip3 = ref(false);
    return {
      tooltip1,
      //tooltip2,
      //tooltip3,
    };
  },

  data() {
    return {
      contributionEngineResult: null,
      contributionsForcedToZeroWarning: false,
      clientConfig,

      formatOptions: {
        salary: {
          numeral: true,
          prefix: "$",
          //prefix: " p/a",
          //tailPrefix: true,
          numeralPositiveOnly: true,
          noImmediatePrefix: true,
          rawValueTrimPrefix: true,
          numeralIntegerScale: 9,
          numeralDecimalScale: 2,
        },
        percentage: {
          numeral: true,
          prefix: " % ",
          tailPrefix: true,
          numeralPositiveOnly: true,
          noImmediatePrefix: true,
          rawValueTrimPrefix: true,
          numeralIntegerScale: 2,
          numeralDecimalScale: 2,
        },
        number: {
          numericOnly: true,
          blocks: [2],
        },
      },
    };
  },

  computed: {
    ...mapFields([
      "salary",
      "salaryFrequency",
      "employerContributionRate",
      "memberType",
      "superEngineConfig",
      "contributionsBeforeTax",
    ]),

    ...mapGetters([
      "debugMode",
      "updateTriggered",
      "data",
      "annualContributionsAfterTax",
      "annualContributionsBeforeTax",
      "annualSpareCashAmount",
      "annualSalary",
      "isResultTabActive",
    ]),
  },

  watch: {
    salary: {
      handler() {
        this.updateBeforeTaxSalary();
        this.salaryBalanceCheck();
      },
      immediate: true
    },

    salaryFrequency() {
      this.updateBeforeTaxSalary();
    },

    employerContributionRate: {
      handler() {
        this.updateEmployerContributionRate();
      },
      immediate: true
    },
  },

  methods: {
    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function () {
        rf.$refreshIframeHeight();
      }, 300);
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ccApp");

      this.triggerHeightCheck();

      this.$gtag.event("click", {
        event_category: "navigation",
        event_label: "navigateTo" + tabNum,
        value: 1,
      });

      // reset this when user clicking ahead
      if (tabNum == 3 ){
        this.contributionsForcedToZeroWarning = false;
      }

      if (this.debugMode) console.log("GTAG Event: navigateTo" + tabNum);
    },

    changeMemberType(event) {
      const selectedMemberType = parseInt(event.target.options[event.target.options.selectedIndex].getAttribute('data-membertype'));
      const selectedTaxedFund = event.target.options[event.target.options.selectedIndex].getAttribute('data-taxedfund') === 'true';

      this.superEngineConfig.MemberType = selectedMemberType;
      this.superEngineConfig.MemberType_2 = selectedMemberType;
      this.$store.commit("updateTaxedFund", selectedTaxedFund);

      var spareCashSafetyThreshold = (this.annualSalary - this.annualContributionsAfterTax - this.annualContributionsBeforeTax)  * 0.5;

      if (this.annualContributionsBeforeTax > clientConfig.params.contributionsBeforeTax.max){
        this.$store.commit("updateContributionsBeforeTax", 0);
        this.contributionsForcedToZeroWarning = true;
      } else {
        this.contributionsForcedToZeroWarning = false;
      }

      if (this.annualSpareCashAmount >  spareCashSafetyThreshold && selectedTaxedFund == true){
        this.$store.commit("updateSpareCashAmount", 0);
        this.contributionsForcedToZeroWarning = true;
      } else {
        this.contributionsForcedToZeroWarning = false;
      }
    },

    updateBeforeTaxSalary() {
      this.$store.commit("updateAnnualBeforeTaxSalaryForEngine");
    },

    updateEmployerContributionRate() {
      this.$store.commit("updateEmployerContributionRateForEngine");
    },

    // refactor... to make it more universal for more than one salary fields
    enforceTypedSalaryAmountMinMax(frequency, cashflowMax){
      switch(frequency) {
        case "week":
          cashflowMax = cashflowMax * clientConfig.params.frequency.week
          break;
        case "fortnight":
            cashflowMax = cashflowMax * clientConfig.params.frequency.fortnight
          break;
        case "month":
            cashflowMax = cashflowMax * clientConfig.params.frequency.month
          break;
      }
      if (this.salary > cashflowMax) {
        this.salary = this.$roundTo(cashflowMax);
      }
    },

    salaryBalanceCheck(){
      this.salaryBalance = this.annualSalary - this.annualContributionsBeforeTax - this.annualContributionsAfterTax - this.annualSpareCashAmount;
      // toggle Error Msg based on if contributions amount is greater than salary
      if (this.salaryBalance < 0) {
        this.contributionsIsGreaterThanSalary = true;
        this.$store.commit("setIsResultTabActive", false);
      } else {
        this.contributionsIsGreaterThanSalary = false;
        this.$store.commit("setIsResultTabActive", true);
      }
    }

  },

  mounted() {
    this.triggerHeightCheck();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },

  unmounted() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  },
};
</script>

<template>
  <MDBContainer fluid>
    <MDBRow class="p-0">
      <MDBCol md="11" class="main-content-wrapper about-wrapper">
        <div v-html="clientConfig.content.about.header"></div>
        <div v-html="clientConfig.content.about.content"></div>

        <MDBRow>
          <MDBCol sm="4" md="4">
            <div class="form-group about first">
              <label for="ageInput" tabindex="0">
                {{ clientConfig.content.about.ageLabel }}
              </label>
              <NumInput
                  v-model.number="superEngineConfig.AgeNow"
                  :options="{
                    precision: 0,
                    currencyDisplay: 'hidden',
                    valueRange: { min: data.ageNow.min, max: data.ageNow.max }
                  }"
                  name="ageNow"
                  type="text"
                  id="age"
                  class=""
                  tabindex="0"
                />
            </div>
          </MDBCol>
          <MDBCol></MDBCol>
        </MDBRow>

        <div class="form-group about">
          <label for="inputSalary" tabindex="0">
            {{ clientConfig.content.about.beforeTaxSalaryLabel }}
          </label>
          <MDBRow>
            <MDBCol sm="4" md="4">
              <cleave
                v-model.number.lazy="salary"
                :options="formatOptions.salary"
                name="salary"
                type="text"
                id="salary"
                class="form-control mini-input"
                tabindex="0"
                @change="$enforceFieldMinMax($event, salaryFrequency)"
                :min="data.salary.min"
                :max="data.salary.max"
              ></cleave>
            </MDBCol>

            <MDBCol sm="4" md="4">
              <select
                v-model="salaryFrequency"
                class="form-control select time-select"
                @change="enforceTypedSalaryAmountMinMax(salaryFrequency, data.salary.max)"
              >
                <option selected value="year">per year</option>
                <option value="month">per month</option>
                <option value="fortnight">per fortnight</option>
                <option value="week">per week</option>
              </select>
            </MDBCol>
          </MDBRow>
          <div class="error-msg contributions pt-2" v-show="!isResultTabActive">
            <div class="alert alert-danger" role="alert">
              <div v-html="clientConfig.content.about.salaryIsBelowContributionAmountError"></div>
            </div>
          </div>
        </div>

        <MDBRow>
          <MDBCol sm="4" md="4" class="form-group about">
            <label for="typedSuperBalance" tabindex="0">
              {{ clientConfig.content.about.currentSuperBalanceLabel }}
            </label>
            <NumInput
                v-model.number="superEngineConfig.SuperannuationBalance"
                :options="{
                  precision: 0,
                  valueRange: { min: data.superannuationBalance.min, max: data.superannuationBalance.max }
                }"
                name="superannuationBalance"
                type="text"
                id="superannuationBalance"
                class=""
                tabindex="0"
              />
          </MDBCol>

          <MDBCol sm="4" md="4" class="form-group about">
            <label for="employerContributionRate" tabindex="0">
              {{ clientConfig.content.about.employerContributionsLabel }}
            </label>
            <MDBRow>
              <MDBCol>
                <cleave
                  v-model.number="employerContributionRate"
                  :options="formatOptions.percentage"
                  name="employerContributionRate"
                  type="text"
                  id="employerContributionRate"
                  class="form-control mini-input percentage"
                  tabindex="0"
                  @change="$enforceFieldMinMax($event)"
                  :min="data.employerContributionRate.min"
                  :max="data.employerContributionRate.max"
                >
                </cleave>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>

        <MDBRow v-if="clientConfig.content.about.whichFundOptions">
          <div class="form-group about col-md-6">
            <label for="inputMemberType" tabindex="0">
              {{ clientConfig.content.about.whichFundLabel }}
              <small
                id="ageHelp"
                class="form-text text-muted"
                v-if="clientConfig.content.about.showWhichFundLink"
              >
                <a :href="clientConfig.content.about.whichFundLink">
                  {{ clientConfig.content.about.whichFundLinkText }}
                </a>
              </small>
            </label>

            <select
              v-model="memberType"
              class="form-control select"
              @change="changeMemberType($event)"
            >
              <option
                v-for="(option, index) in clientConfig.content.about.whichFundOptions"
                :key="index"
                :value="option.memberType"
                :data-memberType="option.memberType"
                :data-taxedFund="option.taxedFund"
              >
                {{ option.optionLabel }}
              </option>
            </select>
            <MDBTooltip v-model="tooltip1" boundary="#ccApp" direction="top">
              <template #reference>
                <span class="icon-info">
                <InfoIcon />
              </span>
              </template>
              <template #tip>
                <span>
                  {{ clientConfig.content.about.whichFundTooltip }}
                </span>
              </template>
            </MDBTooltip>
            <div class="text-info pt-3 warning" :class="contributionsForcedToZeroWarning ? 'show-warning' : 'hide-warning'">
              <span v-html="clientConfig.content.about.whichFundWarning"></span>
            </div>
          </div>
        </MDBRow>

        <MDBRow>
          <MDBCol md="11" class="text-center mx-auto my-5">
            <MDBBtn
              outline="secondary"
              class="rounded me-2"
              @click="clickToTab(1);"
              aria-label="Back button"
            >
              {{ clientConfig.content.about.backButtonLabel }}
            </MDBBtn>

            <MDBBtn
              color="primary"
              class="rounded next"
              @click="clickToTab(3);"
              aria-label="Continue button"
            >
              {{ clientConfig.content.about.nextButtonLabel }}
              <i class="fas icon-arrow"></i>
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>
